(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("shop", [], factory);
	else if(typeof exports === 'object')
		exports["shop"] = factory();
	else
		root["shop"] = factory();
})(self, () => {
return 